import { Component, createRef } from 'react'
import clx from 'classnames'
import { FormSection } from 'redux-form'
import _ from 'lodash'
import { Typography } from 'antd'
import { Modal } from '@vzmi/shp_shared_compo'
import SortableTable, {
  DragHandler
} from '../../../../../Common/SortableTable/SortableTable'
import { PRODUCT_KEY, PRODUCT_MODAL_TYPE } from '../../constants'
import styles from './index.css'
import VisibleButton from '../../VisibleButton'
import { InputCountField, MenuSelectField } from '../../../../../Common/Form'
import { formDecorator, Field } from '../../../../../Common/forms'

const { Paragraph } = Typography

export const CONFIG = {
  form: 'UPDATE_LISTING_MODEL_SPEC_SORT_FORM',
  section: 'TABLE',
  initialValues: {}
}

export const getIsActionsInvisible = (data, record) => {
  const visibleKey = PRODUCT_KEY.SPEC_VISIBLE
  const visibleStateRows = _.filter(data, row => _.get(row, visibleKey))
  const isVisible = _.get(record, visibleKey)
  const isActionsInvisible = (
    // 狀態為顯示
    isVisible &&
    // 只剩一筆時就不能再操作
    (_.size(visibleStateRows) <= 1)
  )
  return isActionsInvisible
}

const getColumns = (columnsProps, data, readOnly) => [
  {
    key: 'sortableIcon',
    width: 50,
    render: (text, record) => (
      <DragHandler
        id={`product${_.get(record, PRODUCT_KEY.ID)}`}
        className={clx({ [styles.editableOffset]: !readOnly })}
        disabled={readOnly}
      />
    )
  },
  {
    dataIndex: PRODUCT_KEY.ATTRIBUTES,
    key: PRODUCT_KEY.ATTRIBUTES,
    title: '屬性項目',
    render: (text, record) => {
      if (!columnsProps.attrsFeatureToggle) {
        return null
      }

      if (readOnly) {
        const firstAttr = _.get(record, `${PRODUCT_KEY.ATTRIBUTES}[0].values[0]`)
        return (
          <Paragraph ellipsis={{ rows: 2 }}>
            {firstAttr}
          </Paragraph>
        )
      }

      const { attributesOptionsMapByName } = columnsProps
      const productId = _.get(record, PRODUCT_KEY.ID)
      const layerOneAttributeName = _.get(record, `${PRODUCT_KEY.ATTRIBUTES}[0].name`)
      const attributesOptions = _.get(attributesOptionsMapByName, `${layerOneAttributeName}.options`, [])
      return (
        <Field
          name={`${productId}-${PRODUCT_KEY.ATTRIBUTES}[0].values`}
          component={MenuSelectField}
          className={styles.productSpecInput}
          options={attributesOptions}
          enableFilter={false}
          placeholder='請輸入項目'
          keepErrorPosition
        />
      )
    }
  },
  {
    dataIndex: PRODUCT_KEY.SPEC_SELECTED_VALUE,
    key: PRODUCT_KEY.SPEC_SELECTED_VALUE,
    title: '項目顯示名稱',
    render: (text, record) => {
      if (readOnly) {
        return (
          <Paragraph ellipsis={{ rows: 2 }}>
            {text}
          </Paragraph>
        )
      }

      const productId = _.get(record, PRODUCT_KEY.ID)
      return (
        <Field
          name={`${productId}-${PRODUCT_KEY.SPEC_SELECTED_VALUE}`}
          component={InputCountField}
          className={styles.productSpecInput}
          countLimit='100'
          placeholder='請輸入項目'
          keepErrorPosition
        />
      )
    }
  },
  {
    dataIndex: 'action',
    key: 'action',
    width: 60,
    render: (text, record) => {
      const isActionsInvisible = getIsActionsInvisible(data, record)
      if (isActionsInvisible) {
        return <span className={styles.emptyBtn} />
      }

      const { onProductModalOpen, onChangeProductVisible } = columnsProps
      const recordWithState = { ...record, inModal: true }
      const isVisible = _.get(record, PRODUCT_KEY.SPEC_VISIBLE)
      return (
        <VisibleButton
          record={record}
          // 修改第一層屬性，不管是不是雙層屬性賣場他都只需要第一層
          isTwoLayerAttr={false}
          onClick={
            () => isVisible
              ? onProductModalOpen([recordWithState], PRODUCT_MODAL_TYPE.VISIBLE)
              : onChangeProductVisible(recordWithState)
          }
          className={clx({ [styles.editableOffset]: !readOnly })}
          readOnly={readOnly}
        />
      )
    }
  }
]

class SpecSortModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      data: []
    }
    this.sortableTable = createRef()
    this.tableKey = 'spec-sort-modal'
    this.columnsProps = {
      attrsFeatureToggle: this.props.attrsFeatureToggle,
      attributesOptionsMapByName: this.props.attributesOptionsMapByName,
      onProductModalOpen: this.props.columnsProps.onProductModalOpen,
      onChangeProductVisible: this.onChangeProductVisible
    }
  }

  componentDidUpdate (prevProps) {
    if (!prevProps.visible && this.props.visible) {
      this.setTableData()
    }
  }

  setTableData = () => {
    const {
      dataMap,
      sortList,
      change,
      attributesOptionsMapByName,
      attrsFeatureToggle
    } = this.props
    const data = _.map(sortList, (key, index) => {
      const {
        [PRODUCT_KEY.SPEC_SELECTED_VALUE]: name,
        [PRODUCT_KEY.SPEC_VISIBLE]: isVisible,
        [PRODUCT_KEY.ID]: id,
        [PRODUCT_KEY.ATTRIBUTES]: attributes
      } = _.get(dataMap, `['${key}'][0]`, {})
      return {
        key: id,
        index,
        [PRODUCT_KEY.SPEC_SELECTED_VALUE]: name,
        [PRODUCT_KEY.SPEC_VISIBLE]: isVisible,
        [PRODUCT_KEY.ID]: id,
        [PRODUCT_KEY.ATTRIBUTES]: attributes
      }
    })
    const formData = _.reduce(data, (dataMapById, item) => {
      const {
        [PRODUCT_KEY.ID]: id,
        [PRODUCT_KEY.SPEC_SELECTED_VALUE]: value,
        [PRODUCT_KEY.ATTRIBUTES]: attributes
      } = item
      _.set(dataMapById, [`${id}-${PRODUCT_KEY.SPEC_SELECTED_VALUE}`], value)
      _.set(dataMapById, [`${id}-${PRODUCT_KEY.ATTRIBUTES}`], attributes)
      return dataMapById
    }, {})
    this.setState({ data })
    this.columnsProps.attributesOptionsMapByName = attributesOptionsMapByName
    this.columnsProps.attrsFeatureToggle = attrsFeatureToggle
    change(CONFIG.section, formData)
  }

  onChangeProductVisible = (record) => {
    const { data } = this.state
    const id = _.get(record, PRODUCT_KEY.ID)
    const isVisible = _.get(record, PRODUCT_KEY.SPEC_VISIBLE)
    const newData = _.map(data, item => {
      if (_.get(item, PRODUCT_KEY.ID) === id) {
        return { ...item, [PRODUCT_KEY.SPEC_VISIBLE]: !isVisible }
      }
      return item
    })
    this.setState({ data: newData })
  }

  render () {
    const { data } = this.state
    const {
      dataMap,
      sortList,
      checkToStoreAction,
      readOnly,
      attrsFeatureToggle,
      ...restProps
    } = this.props
    return (
      <Modal
        title={<h1><br /></h1>}
        okText={readOnly ? '確認' : '確認修改'}
        cancelText='放棄修改'
        cancelButtonVisible={!readOnly}
        className={this.tableKey}
        {...restProps}
      >
        <form>
          <FormSection name={CONFIG.section}>
            <SortableTable
              container={this.tableKey}
              ref={this.sortableTable}
              columns={getColumns(this.columnsProps, data, readOnly)}
              data={data}
              showHeader={attrsFeatureToggle}
              checkToStoreAction={checkToStoreAction}
              className={styles.table}
              useWindowAsScrollContainer={false}
              noLastBorder
            />
          </FormSection>
        </form>
      </Modal>
    )
  }
}

export default formDecorator(CONFIG)(SpecSortModal)
